import React, { Component } from 'react';
import ReceiptComponent from '../../Components/Book/Receipt/Receipt';
import defaultReceipt from '../../Constants/receipt';

export default class Receipt extends Component {
	render(): React.ReactElement {
		return (
			<ReceiptComponent data={defaultReceipt} />
		);
	}
}
